module.exports = __webpack_public_path__ + "img/covid19-gracias.819fafd4.png";